import { UIText2 } from '@cian/ui-kit';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectIsCpcOffer } from 'shared/selectors/offerData/selectIsCpcOffer';
import { selectOfferPromoDescription } from 'shared/selectors/offerData/selectOfferPromoDescription';
import { selectIsPerformanceVasPilot } from 'shared/selectors/selectIsPerformanceVasPilot';
import { selectUserType } from 'shared/selectors/user';
import { EUserType } from 'shared/types/user';

import styles from './OfferPromotionDescription.css';

export const OfferPromotionDescription = () => {
  const promotionDescription = useSelector(selectOfferPromoDescription);
  const isPromotionVasPilot = useSelector(selectIsPerformanceVasPilot);
  const isCpcOffer = useSelector(selectIsCpcOffer);
  const userType = useSelector(selectUserType);

  const isUserTypeDefined = userType !== EUserType.Undefined;

  const shouldShowContent = promotionDescription && isUserTypeDefined && (isCpcOffer || isPromotionVasPilot);

  if (!shouldShowContent) {
    return null;
  }

  return (
    <div className={styles['wrapper']}>
      <UIText2 fontWeight="bold" color="text-warning-default">
        {promotionDescription}
      </UIText2>
    </div>
  );
};
